import React, { useState } from 'react'
import { toggleModal } from '../../../reducers/modalReducer'
import { useDispatch } from 'react-redux'

const HelpCard = ({ index, title, description }) => {
    const [isHovered, setIsHovered] = useState(false)

    let image = ''
    if (!index) {
        image = require('../../../../images/fractional/help/1.svg')
    }
    if (index === 1) image = require('../../../../images/fractional/help/2.svg')
    if (index === 2) image = require('../../../../images/fractional/help/3.svg')

    return (
        <div
            className='bg1 br20px p2rem df fdc aifs jcfs'
            style={{
                flex: '1',
                margin: '0 0.5rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <img src={image} alt='help/1' style={{ width: '80px', height: '80px', marginBottom: '1rem', objectFit: 'contain' }} />
            <h2 className='c15 tal fs1-5rem fw500 w100 mb2rem' style={{ lineHeight: '1.9rem' }}>{title}</h2>
            {description && (
                <div style={{
                    overflow: 'hidden',
                    transition: 'height 0.4s ease, opacity 0.3s ease',
                    height: isHovered ? 'auto' : '0px',
                    opacity: isHovered ? 1 : 0
                }}>
                    <p style={{ color: '#514949' }} className='fs15px'>{description}</p>
                </div>
            )}
        </div>
    )
}

const FractionHelpSection = () => {
    const dispatch = useDispatch()

    const cards = [{
        title: `Quickly Organise Your Clients' Data`,
        description: 'Enabling you to more quickly deliver the objectives for which you were engaged - whether investment, growth or exit'
    }, {
        title: `Enable More High-Value, Billable Work`,
        description: 'Our structured process, including quarterly reviews, identifies new opportunities for you to add value to your clients, bill more days and extend your longevity'
    }, {
        title: `Connect With Your Next High-Growth Client`,
        description: 'Join our platform and get warm introductions to companies actively seeking fractional CFO expertise, from sources such as Seedlegals, Innovate UK affiliates, top 10 accountants'
    }]

    return (
        <div className='pr fractionHelpSection' style={{ height: '450px' }}>

            <div
                className='br20px p3rem pa'
                style={{
                    background: '#F5F7FF',
                    width: '85%',
                    left: 'calc(50% - 42.5%)',
                    top: '0px'
                }}
            >
                <div className='df aic jcsb '>
                    <div>
                        <h3 className='c15 fs1-75rem fw400'>How do we help <sapn className='c4'>you</sapn>?</h3>
                        <p className='fs18px c15'>Client impact accelerator - Built by fractional CFOs for Fractional CFOs</p>
                    </div>
                    {/* <div className='bg1 c4 bw1px bss bo4 br20px w300px df aic jcsb' style={{
                        padding: '4px 32px'
                    }}>
                        <span className='fs14px fw500 cp'
                            onClick={() => dispatch(toggleModal({ open: 'fractionHelpClientInfo' }))}
                            style={{
                                lineHeight: 1.5
                            }}>
                            Adding Value To Fractional <br></br>
                            CFO Organisations
                        </span>
                        <span>
                            <img src={require('../../../../images/fractional/right-arrows1.svg')} alt='rightArrow' />
                        </span>
                    </div> */}
                </div>

                <div className='df jcsb mt3rem' style={{ gap: '1rem', flexWrap: 'wrap' }}>
                    {
                        cards.map((card, index) => {
                            return <HelpCard key={index} index={index} title={card.title} description={card.description} />
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default FractionHelpSection